module.exports = __webpack_public_path__ + "static/media/service-img-03.3d566f6c.png";